/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import type { ComponentChild } from 'preact';
import { useErrorBoundary } from 'preact/hooks';

// Core
import useContext, { ClientContext } from '@/client/context';

// Core components
import RouterComponent from '@client/services/router/components/router';
import { Button, Link } from '@client/components';

// app
import AnnouncementsModal from './AnnouncementsModal';

// Resources
import "./index.less";
import Logo from '@/client/assets/identity/logoAndTextBlack.png';

/*----------------------------------
- COMPOSANT
----------------------------------*/
export default function App ({ context, menu }: { 
    context: ClientContext,
    menu: ComponentChild
 }) {

    /*----------------------------------
    - INIT
    ----------------------------------*/

    const { Router, api, modal, user, app, toast } = useContext();
    
    // Render bug report
    // TIDO: move to framework
    useErrorBoundary( e => {
        app.reportBug({
            before: 'Render page',
            stacktrace: e.stack
        }).then(() => {

            // Reload page
            if (__DEV__) {
                console.warn(`The app would be reloaded in production mode.`);
                toast.error(`Errur during page rendering: ${e.message}`);
            } else
                window.location.reload();
        })
    });

    /*----------------------------------
    - ACTIONS
    ----------------------------------*/

    React.useEffect(() => {

    }, []);

    /*----------------------------------
    - RENDER
    ----------------------------------*/

    return (
        <div id="layout" class={"employer"}>

            <div class="col al-center">
                <img src={Logo} />
            </div>

            <RouterComponent service={Router} />
        </div>
    )
}